import React, { Fragment, useEffect, useState } from 'react';
import {
  Typography,
  Button,
  Form,
  message,
  Input,
  Select,
  Tabs,
  Modal,
  Spin,
} from 'antd';
import Axios from 'axios';
import { useSelector } from 'react-redux';
import { filterAccessibleSeasons } from '../../../utils/seasonFilter';
const { Option } = Select;
const { Title, Text } = Typography;

const CompanySum50020Page = () => {
  const [groups, setGroups] = useState([]); //グループ名とグループコード
  const [selGroupInfo, setSelGroupInfo] = useState([]); //選択されたグループ情報
  const [selGroupCode, setSelGroupCode] = useState(''); //選択されたグループコード
  const [survey, setSurvey] = useState([]); //全てのサーベイ情報
  const [groupSurveySeasonInfo, setGroupSurveySeasonInfo] = useState([]); //選択されたグループに存在するサーベイシーズン
  const [selSurveySeasonInfo, setSelSurveySeasonInfo] = useState([]); //選択されたサーベイシーズン情報
  const [selSurveySeasonId, setSelSurveySeasonId] = useState(''); //選択されたサーベイシーズンID
  const [submitSW, setSubmitSW] = useState(true); //SubmitボタンDisable調整 true => 表示
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [e3CompanyEMP, setE3CompanyEMP] = useState([]);
  const [e3CompanyValue, setE3CompanyValue] = useState([]);

  const usr = useSelector((state) => state.user);

  const readDB = async () => {
    try {
      if (!usr.userData) return null;
      // console.log({ usr });
      setUserInfo(usr.userData);
      // const groupInfo = await Axios.get('api/group/');

      const [surveyInfo, groupInfo] = await Promise.all([
        Axios.get('/api/survey/'), //DBからサーベイ情報取得
        Axios.get('/api/group/50020'), //DBからグループ情報取得
        // Axios.get('/api/surveySeason/'), //DBからシーズン情報取得
        // Axios.get(config.USER_SERVER), //全てのユーザの習得（管理者以外）
      ]);

      setSurvey(surveyInfo.data.survey);
      setGroups(groupInfo.data.groups);

      if (!groups) throw new Error('グループ取得に失敗しました。');
      if (!survey) throw new Error('サーベイ取得に失敗しました。');
      if (usr.userData.role === 3) {
        //企業管理者
        // onChangeGroup(usr.userData.groupCode);
        let sgi = groupInfo.data.groups.find(
          (item) => item.group_code === usr.userData.groupCode
        );

        // console.log({ sgi });
        setSelGroupCode(usr.userData.groupCode);
        setSelGroupInfo(sgi);
        setGroupSurveySeasonInfo(
          filterAccessibleSeasons(sgi.survey_season, usr.userData, ['50020', '90502'])
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    readDB();
    // console.log({ Users });
  }, [usr]);

  const onChangeGroup = (value) => {
    let sgi = groups.find((item) => item.group_code === value);
    // console.log(sgi.department);
    setSelGroupCode(value);
    setSelGroupInfo(sgi);

    // setGroupSurveySeasonInfo(sgi.survey_season);
    // const dp = [];
    // for (let i = 0; i < sgi.department.length; i++) {
    //   if (sgi.department[i].split('／').length < 2) {
    //     dp.push(sgi.department[i]);
    //   }
    // }

    // console.log(dp);
    // const child = [];
    // const dep = [];
    // for (let i = 0; i < dp.length; i++) {
    //   const element = dp[i];
    //   child.push(<Option key={element}>{element}</Option>);
    //   dep.push(element);
    // }

    setGroupSurveySeasonInfo(
      filterAccessibleSeasons(sgi.survey_season, usr.userData, ['50020', '90502'])
    );
    setSelSurveySeasonId('');
  };

  const onChangeSurveySeason = async (value) => {
    const sssi = groupSurveySeasonInfo.find((item) => item._id === value); //selSurveySeasonInfo
    setSelSurveySeasonId(value);
    setSelSurveySeasonInfo(sssi);
    // console.log({ selQuestionSetId });
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    try {
      // message.loading({
      //   content: 'データ作成中...',
      //   key: 'makecsv',
      //   duration: 4,
      // });
      // console.log({ radio });

      setIsModalVisible(true);
      setSubmitSW(false);
      const sendData = {
        selGroupInfo: selGroupInfo,
        selSurveySeasonInfo: selSurveySeasonInfo,
      };
      // console.log({ sendData });
      const res = await Axios.patch(
        '/api/dbModel100/companySum50020',
        sendData
      );
      // console.log({ res });
      setTimeout(() => {
        message.success({
          content: '企業結果集計完了！',
          key: 'makecsv',
          duration: 2,
        });
        setSubmitSW(true);
        setIsModalVisible(false);
        let empText = '';
        let valueText = '';
        for (let i = 0; i < res.data.result.e3CompanyEMP.length; i++) {
          const element = res.data.result.e3CompanyEMP[i].toFixed(2);
          empText += `${i} : ${element}, `;
        }
        for (let i = 0; i < res.data.result.e3CompanyValue.length; i++) {
          const element = res.data.result.e3CompanyValue[i].toFixed(2);
          valueText += `${i} : ${element}, `;
        }
        setE3CompanyEMP(empText);
        setE3CompanyValue(valueText);
      }, 1000);
    } catch (error) {
      console.log(error.message);
      setIsModalVisible(false);
      message.error({
        content: error.message,
        key: 'makecsv',
        duration: 4,
      });
      setSelSurveySeasonId('');
      setSelGroupCode('');
      setSelGroupInfo([]);
      setSubmitSW(true);

      // window.location.reload(false);
    }
  };

  return (
    <Fragment>
      <div style={{ maxWidth: '1100px', margin: '2rem auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <Title level={2}>パーソナリティ診断企業平均集計</Title>
        </div>
        <Form onSubmit={onSubmit}>
          <br />
          <Title style={{ color: 'var(--brand-primary)' }}>❶</Title>
          <Text strong style={{ display: 'block', marginBottom: 'var(--space-4)' }}>企業を選択してください。（必須）</Text>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Select
              showSearch
              style={{ marginLeft: 0, marginRight: 10, width: 300 }}
              placeholder="企業選択"
              optionFilterProp="children"
              onChange={onChangeGroup}
              value={selGroupCode}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              disabled={userInfo.role === 3}
            >
              {groups.map((element) => {
                // console.log({ element });
                return (
                  <Option value={element.group_code} key={element._id}>
                    {element.group_name}
                  </Option>
                );
              })}
            </Select>
          </div>
          <br />
          <div>
            <Title style={{ color: 'var(--brand-primary)' }}>❷</Title>
            <Text strong style={{ display: 'block', marginBottom: 'var(--space-4)' }}>サーベイを選択してください。（必須）</Text>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Select
                showSearch
                style={{ marginLeft: 0, marginRight: 5, width: 400 }}
                placeholder="企業選択"
                optionFilterProp="children"
                onChange={onChangeSurveySeason}
                value={selSurveySeasonId}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {groupSurveySeasonInfo.map((element) => {
                  // console.log({ element });
                  return (
                    <Option value={element._id} key={element._id}>
                      {element.season_name}
                    </Option>
                  );
                })}
              </Select>
            </div>
          </div>
          <br />
          <br />
          <Title style={{ color: 'var(--brand-primary)' }}>❸</Title>
          <Button
            type="primary"
            size="large"
            onClick={onSubmit}
            disabled={!(submitSW && selSurveySeasonId)}
          >
            結果集計開始
          </Button>

          <Title style={{ color: 'var(--brand-primary)' }}>❹</Title>
          <Text strong>総合共感</Text>
          <br />
          <Text code>{e3CompanyEMP}</Text>
          <br />
          <br />
          <Text strong>各項目バリュー</Text>
          <br />
          <Text code>{e3CompanyValue}</Text>
        </Form>
      </div>
      <Modal
        title="結果集計中..."
        open={isModalVisible}
        okButtonProps={{ disabled: true }}
        cancelButtonProps={{ disabled: true }}
        styles={{ body: { textAlign: 'center' } }}
      >
        <Spin size="large" />
      </Modal>
    </Fragment>
  );
};

export default CompanySum50020Page;
